import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAdmin } from '../../context/AdminContext';

const AdminSidebar = ({ isOpen, toggleSidebar }) => {
  const { admin } = useAdmin();
  const location = useLocation();

  // Determine if a link is active
  const isActive = (path) => {
    if (path === '/admin' && location.pathname === '/admin/dashboard') return true;
    return location.pathname.startsWith(path);
  };

  return (
    <div className={`admin-sidebar ${isOpen ? '' : 'collapsed'}`}>
      <div className="sidebar-header p-3">
        <div className="d-flex align-items-center justify-content-between">
          {isOpen && <h3 className="m-0 text-gradient">SPONO</h3>}
          <button 
            className="btn btn-link text-light p-0" 
            onClick={toggleSidebar}
          >
            <i className={`fa fa-${isOpen ? 'angle-left' : 'angle-right'}`}></i>
          </button>
        </div>
      </div>

      <div className="sidebar-content">
        <nav className="sidebar-nav">
          <ul className="nav flex-column">
            <li className="nav-item">
              <Link 
                to="/admin/dashboard" 
                className={`nav-link ${isActive('/admin/dashboard') ? 'active' : ''}`}
              >
                <i className="fa fa-dashboard me-2"></i>
                {isOpen && "Dashboard"}
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/admin/users" 
                className={`nav-link ${isActive('/admin/users') ? 'active' : ''}`}
              >
                <i className="fa fa-users me-2"></i>
                {isOpen && "Users"}
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/admin/events" 
                className={`nav-link ${isActive('/admin/events') ? 'active' : ''}`}
              >
                <i className="fa fa-calendar me-2"></i>
                {isOpen && "Events"}
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/admin/check-ins" 
                className={`nav-link ${isActive('/admin/check-ins') ? 'active' : ''}`}
              >
                <i className="fa fa-check-circle me-2"></i>
                {isOpen && "Check-ins"}
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/admin/moments" 
                className={`nav-link ${isActive('/admin/moments') ? 'active' : ''}`}
              >
                <i className="fa fa-image me-2"></i>
                {isOpen && "Moments"}
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/admin/settings" 
                className={`nav-link ${isActive('/admin/settings') ? 'active' : ''}`}
              >
                <i className="fa fa-cog me-2"></i>
                {isOpen && "Settings"}
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/admin/profile" 
                className={`nav-link ${isActive('/admin/profile') ? 'active' : ''}`}
              >
                <i className="fa fa-user me-2"></i>
                {isOpen && "My Profile"}
              </Link>
            </li>
          </ul>
        </nav>
      </div>

      <div className="sidebar-footer p-3 mt-auto">
        {isOpen && (
          <div className="text-center text-muted small">
            <p className="mb-0">SPONO Admin Panel</p>
            <p className="mb-0">Version 1.0</p>
          </div>
        )}
      </div>

      <style jsx="true">{`
        .admin-sidebar {
          width: 250px;
          height: 100vh;
          position: fixed;
          top: 0;
          left: 0;
          z-index: 1000;
          display: flex;
          flex-direction: column;
          transition: width 0.3s;
          overflow-x: hidden;
          overflow-y: auto;
          background-color: var(--dark-bg-secondary);
          border-right: 1px solid var(--dark-border);
        }
        
        .admin-sidebar.collapsed {
          width: 60px;
        }
        
        .sidebar-header {
          border-bottom: 1px solid var(--dark-border);
        }
        
        .sidebar-content {
          flex: 1;
          overflow-y: auto;
        }
        
        .text-gradient {
          background: linear-gradient(to right, #ff3636, #c93e67);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
        }
        
        .nav-link {
          padding: 0.75rem 1rem;
          border-radius: 0;
          transition: all 0.2s;
          display: flex;
          align-items: center;
          white-space: nowrap;
        }
        
        .nav-link i {
          font-size: 18px;
          width: 24px;
          text-align: center;
        }
        
        .sidebar-footer {
          border-top: 1px solid var(--dark-border);
        }
        
        @media (max-width: 768px) {
          .admin-sidebar {
            transform: translateX(0); /* Changed from translateX(-100%) to make sidebar visible by default */
            z-index: 1030;
          }
          
          .admin-sidebar.collapsed {
            transform: translateX(-100%);
          }
        }
      `}</style>
    </div>
  );
};

export default AdminSidebar;